import { render, staticRenderFns } from "./MotorWithVFD.vue?vue&type=template&id=da8bf1d8&scoped=true&"
import script from "./MotorWithVFD.vue?vue&type=script&lang=ts&"
export * from "./MotorWithVFD.vue?vue&type=script&lang=ts&"
import style0 from "./MotorWithVFD.vue?vue&type=style&index=0&id=da8bf1d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da8bf1d8",
  null
  
)

export default component.exports